import { createFileRoute } from "@tanstack/react-router";
import OwnerVoiceAgentPage from "@/pages/OwnerVoiceAgentPage";

export const Route = createFileRoute("/_owner/owner/voice-agent")({
  component: OwnerVoiceAgentPage,
});
